import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { currencyValidator, requiredValidator } from '../../validators';
import { config } from '../../../../config';
import { dollarsToCents, markAsTouched } from '../../utils';
import { chargeCard, InstantPaymentResponse } from '../../../../../lib/ezidebit';
import { Observable } from 'rxjs/Observable';
import { LogService } from '../../../core/data';

export interface PaymentReference {
  payment_reference: string;

  [key: string]: string;
}

@Component({
  selector: 'app-instant-payment',
  templateUrl: './instant-payment.component.html',
})
export class InstantPaymentComponent implements OnInit, OnChanges {
  @Input() fixedAmountInDollars?: number;
  @Input() allowComments = true;
  @Input() createReference: (amount: number) => Observable<PaymentReference>;
  @Output() onSuccess = new EventEmitter<InstantPaymentResponse>();
  @Output() onError = new EventEmitter<InstantPaymentResponse>();
  hidePaymentAmount = false;

  cardDetails: any = {};
  form = new FormGroup({
    amount: new FormControl(null, [
      requiredValidator(),
      currencyValidator,
      Validators.max(config.PAYMENTS.MAX_AMOUNT.DOLLARS)
    ]),
    comments: new FormControl(null, [
      requiredValidator(),
      Validators.maxLength(10000),
    ])
  });
  errors: string[] = [];
  pending = false;

  constructor(
    private logService: LogService
  ) {
  }

  ngOnInit() {
    if (this.fixedAmountInDollars > 0) {
      this.hidePaymentAmount = true;
    }

    this.form.patchValue({
      amount: this.fixedAmountInDollars,
      comments: this.allowComments ? '' : '-',
    });
  }

  ngOnChanges() {
    if (this.fixedAmountInDollars > 0) {
      this.hidePaymentAmount = true;
    }

    if (this.fixedAmountInDollars !== this.form.get('amount').value) {
      this.form.patchValue({
        amount: this.fixedAmountInDollars,
      });
    }
  }

  getAmount() {
    return dollarsToCents(
      typeof this.fixedAmountInDollars !== 'undefined'
        ? this.fixedAmountInDollars
        : this.form.value.amount
    );
  }

  submit() {
    if (this.pending) {
      return;
    }

    if (!this.form.valid) {
      markAsTouched(this.form);
      return;
    }

    this.errors = [];
    this.pending = true;
    const amount = this.getAmount();

    this.createReference(amount)
      .subscribe((reference) => {
        this.logService.create({
          event: 'admin.instant_payment',
          type: 'request',
          value: {
            card_name: this.cardDetails.name,
            amount,
            ...reference,
          }
        }).subscribe();

        chargeCard(
          reference.payment_reference,
          amount,
          this.cardDetails.number,
          this.cardDetails.expiryMonth,
          this.cardDetails.expiryYear,
          this.cardDetails.cvc,
          this.cardDetails.name
        )
          .then((paymentReference) => {
            if (paymentReference.success) {
              this.onSuccess.emit(paymentReference);
            } else {
              this.errors.push(`Error: ${paymentReference.message}`);
              this.pending = false;

              this.logService.create({
                event: 'admin.instant_payment',
                type: 'response',
                value: {...reference, response: paymentReference.response}
              }).subscribe();

              this.onError.emit(paymentReference);
            }
          })
          .catch(() => {
            this.errors = ['An unknown error has occurred. Please try again.'];
          });
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/payments/instant-payment.component.ts